'use client'

import { useState, useEffect } from 'react'

export const useScrollDirection = () => {
  const [scrollDirection, setScrollDirection] = useState<'up' | 'down' | null>(null)
  const [lastScrollY, setLastScrollY] = useState(0)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const updateScrollDirection = () => {
      const scrollY = window.scrollY
      const direction = scrollY > lastScrollY ? 'down' : 'up'

      // Добавляем threshold чтобы избежать дрожания при мелких движениях
      if (Math.abs(scrollY - lastScrollY) > 10) {
        setScrollDirection(direction)
        setLastScrollY(scrollY)
      }

      // Отслеживаем, прокручена ли страница
      setIsScrolled(scrollY > 50)
    }

    const handleScroll = () => {
      updateScrollDirection()
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [lastScrollY])

  return { scrollDirection, isScrolled }
}
